import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Link, useMatch } from "@tanstack/react-router";

export default function AdminBreadcrumb({ title }: { title: string }) {
  const dashboardMatch = useMatch({
    from: "/admin/dashboard",
    shouldThrow: false,
  });
  const clientMatch = useMatch({ from: "/admin/client", shouldThrow: false });
  const clientAddMatch = useMatch({
    from: "/admin/client/add",
    shouldThrow: false,
  });
  const clientDetailMatch = useMatch({
    from: "/admin/client/$clientId",
    shouldThrow: false,
  });
  const clientEditMatch = useMatch({
    from: "/admin/client/edit",
    shouldThrow: false,
  });
  const requestsMatch = useMatch({
    from: "/admin/requests",
    shouldThrow: false,
  });
  const systemMatch = useMatch({
    from: "/admin/system",
    shouldThrow: false,
  });

  const managerSubscriptionManagementMatch = useMatch({
    from: "/manager/subscription-management",
    shouldThrow: false,
  });
  const managerAddNewUserMatch = useMatch({
    from: "/manager/subscription-management/add-new-user",
    shouldThrow: false,
  });
  const managerEditUserMatch = useMatch({
    from: "/manager/subscription-management/edit-user/$hashKeyId",
    shouldThrow: false,
  });
  const managerAddNewTokenMatch = useMatch({
    from: "/manager/subscription-management/add-new-token",
    shouldThrow: false,
  });
  const managerTeamManagementMatch = useMatch({
    from: "/manager/team-management",
    shouldThrow: false,
  });
  const managerSubscriptionOverviewMatch = useMatch({
    from: "/manager/subscription-management/overview",
    shouldThrow: false,
  });
  const managerSubscriptionUsageMatch = useMatch({
    from: "/manager/subscription-management/usage",
    shouldThrow: false,
  });
  const managerSubscriptionActivityMatch = useMatch({
    from: "/manager/subscription-management/activity",
    shouldThrow: false,
  });
  return (
    <div className="space-y-1">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink className="cursor-pointer" asChild>
              {dashboardMatch ||
              clientMatch ||
              clientDetailMatch ||
              clientAddMatch ||
              clientEditMatch ||
              requestsMatch ||
              systemMatch ? (
                <Link to="/admin/dashboard" className="font-bold">
                  Admin
                </Link>
              ) : managerTeamManagementMatch ||
                managerSubscriptionManagementMatch ||
                managerAddNewUserMatch ||
                managerEditUserMatch ||
                managerAddNewTokenMatch ||
                managerSubscriptionOverviewMatch ||
                managerSubscriptionUsageMatch ||
                managerSubscriptionActivityMatch ? (
                <Link to="/manager/team-management" className="font-bold">
                  Manager
                </Link>
              ) : null}
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink className="font-bold" asChild>
              {dashboardMatch ? (
                <Link to="/admin/dashboard" className="font-bold">
                  Dashboard
                </Link>
              ) : clientMatch || clientEditMatch ? (
                <Link to="/admin/client" className="font-bold">
                  Client
                </Link>
              ) : requestsMatch ? (
                <Link to="/admin/requests" className="font-bold">
                  Requests
                </Link>
              ) : systemMatch ? (
                <Link to="/admin/system" className="font-bold">
                  System
                </Link>
              ) : managerSubscriptionManagementMatch ||
                managerAddNewTokenMatch ? (
                <Link
                  to="/manager/subscription-management"
                  className="font-bold"
                >
                  Subscription Management
                </Link>
              ) : managerTeamManagementMatch ||
                managerAddNewUserMatch ||
                managerEditUserMatch ? (
                <Link to="/manager/team-management" className="font-bold">
                  Team Management
                </Link>
              ) : (
                <Link to="/admin/client" className="font-bold">
                  Client
                </Link>
              )}
            </BreadcrumbLink>
          </BreadcrumbItem>
          {clientDetailMatch && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink className="font-bold">{title}</BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}

          {clientAddMatch && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink className="font-bold">
                  Add new client
                </BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}
          {clientEditMatch && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink className="font-bold">
                  Edit client
                </BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}
          {managerAddNewUserMatch && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink className="font-bold">
                  Add new hash key
                </BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}

          {managerEditUserMatch && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink className="font-bold">{title}</BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}

          {managerAddNewTokenMatch && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink className="font-bold">
                  Create new token
                </BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>
      <h1 className="text-xl leading-[36px] font-bold -tracking-wide">
        {title}
      </h1>
    </div>
  );
}
